import classNames from 'classnames';

import * as store from '@/store';
import CommentActiveIcon from '@/assets/svg/ai/commentActive2.svg?tsx';
import CommentIcon from '@/assets/svg/ai/commentNormal2.svg?tsx';
import UnExpand from '@/assets/svg/ai/unExpand.svg?tsx';
import Bar from '@/assets/svg/ai/bar.svg?tsx';
import Icon, {IconSize} from '@/components/Icon';
import {reportClickClosePanel} from '@/buried/aigc';
import {AIChatPanelExpandSource, aiChatPanelExpandSourceObj} from '@/utils/document/aigc';
import {useVerifyEditorDialog} from '@/domains/document/DocHome/Document/Dialogs/useVerifyEditorDialog';
import {SideTabKey, IAiChatPanel} from '@/interface';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';

import {closePanel, openPanel} from '../utils/panelStatus';
import styles from './style.module.scss';

const tabs = [
    {
        value: SideTabKey.Comment,
        label: '评论',
        icon: CommentIcon,
        selectedIcon: CommentActiveIcon,
    },
];

interface IProps {
    show: boolean;
    isAiAssistant: boolean;
    docGuid: string;
}

const {
    useIsInGray: useIsAutoSavedCommentGray,
} = initGray(GRAY_RELEASE_KEYS.autoSavedComment);

const Header: React.FC<IProps> = ({
    show,
    isAiAssistant,
    docGuid,
}) => {
    const aiChatPanel: IAiChatPanel = store.getAiChatPanel();
    const {selectedTab} = aiChatPanel;
    const mode = store.getDocumentMode();
    const isAutoSavedCommentGray = useIsAutoSavedCommentGray();

    const {
        VerifyEditorDialog,
        verifiedEvents,
    } = useVerifyEditorDialog(true, mode);

    function handleChangeTab(e: any, value: SideTabKey) {
        e.stopPropagation();
        aiChatPanelExpandSourceObj.value = AIChatPanelExpandSource.entryIcon;
        openPanel({
            tab: value,
        });
    }

    function handleClose() {
        reportClickClosePanel({pageId: docGuid});

        closePanel();
    }

    return (
        <div className={
            classNames(
                styles.header,
                isAiAssistant && styles.isAiAssistant,
                !show && styles.hidden
            )}
        >
            <div className={styles.tabs}>
                {
                    tabs.map((tab) => {
                        const isSelected = selectedTab === tab.value;
                        const IconComp = isSelected ? tab.selectedIcon : tab.icon;
                        return (
                            <div
                                key={tab.value}
                                className={classNames(styles.tab, isSelected ? styles.selected : undefined)}
                                onClick={(e) => handleChangeTab(e, tab.value)}
                            >
                                <IconComp
                                    className={classNames(tab.value === SideTabKey.Ai && styles.aiIcon)}
                                />
                                {tab.label}
                            </div>
                        );
                    })
                }
                <div style={{left: '22px'}} className={styles.bar}>
                    <Icon svg={Bar} size={IconSize.Auto} />
                </div>
            </div>
            {/* 评论丢失优化小流量，非小流量用户保持以前逻辑，显示弹窗 */}
            <div
                className={styles.close}
                onClick={isAutoSavedCommentGray ? handleClose : verifiedEvents(handleClose, true)}
            >
                <Icon svg={UnExpand} size={IconSize.Auto} />
            </div>
            <VerifyEditorDialog />
        </div>
    );
};

export default Header;
